import { httpClient } from "./client";
import type { ModerationApi } from "./interfaces";
import type {
  AppealCreate,
  AppealSubmissionResponse,
  ReportCreate,
  ReportSubmissionResponse,
  SelfModerationStatusResponse,
} from "../types/generated";

export const moderationApi: ModerationApi = {
  submitReport: (data: ReportCreate) =>
    httpClient.post<ReportSubmissionResponse>("/moderation/reports", data),

  getMyModerationStatus: () =>
    httpClient.get<SelfModerationStatusResponse>("/moderation/me/status"),

  submitBanAppeal: (banId: string, data: AppealCreate) =>
    httpClient.post<AppealSubmissionResponse>(
      `/moderation/me/bans/${encodeURIComponent(banId)}/appeal`,
      data,
    ),
};
